import { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { decryptToken } from "../Utlis/Encryption";
import { BASE_URL } from "../components/BaseUrl";
import { isMenuAllowedForPlan } from "../utils/planMenuAccess";

const usePlanAccess = () => {
  const token = useSelector((state) => state.auth.token);
  const trialInfo = useSelector((state) => state.auth.trialInfo);
  const decryptedToken = token ? decryptToken(token) : null;
  const [planId, setPlanId] = useState(null);

  useEffect(() => {
    if (!decryptedToken) return;

    const fetchPlan = async () => {
      try {
        const res = await fetch(`${BASE_URL}/payments/company-admin/plan-details`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
        });
        const json = await res.json();
        setPlanId(json?.data?.current_plan?.plan_id || null);
      } catch (err) {
        console.error("Error fetching plan details:", err);
      }
    };

    fetchPlan();
  }, [decryptedToken]);

  const effectivePlanId = planId ?? trialInfo?.current_plan?.plan_id ?? null;
  const canAccess = useCallback(
    (menuKey) => isMenuAllowedForPlan(effectivePlanId, menuKey),
    [effectivePlanId]
  );

  return { effectivePlanId, canAccess };
};

export default usePlanAccess;
